export type FacebookTracking = {
  fbclid: string;
};

export type WithFacebookTracking = Partial<FacebookTracking>;

export const FACEBOOK_TRACKING_KEY = 'fbclid';
